import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReferralSchemeDateRange } from '../model/referral-schmem-date.model';

enum Tabs {
    BORROWER = 0,
    INVESTOR = 1,
}  
@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css'],
})
export class TermsComponent implements OnInit {
  raferralDate: ReferralSchemeDateRange;
  public tabIndex: number = 0;
  constructor(private route: ActivatedRoute) {}
  ngOnInit() {
    const selectedTab = this.route.snapshot.queryParams['selectedTab'];
    this.processSelectedTabParameter(selectedTab);
  }

  private processSelectedTabParameter(tab: string) {
    tab = tab.toUpperCase();
    switch (tab) {
      case 'BORROWER':
        this.tabIndex = Tabs.BORROWER;
        break;
      case 'INVESTOR':
        this.tabIndex = Tabs.INVESTOR;
        break;
      default:
        this.tabIndex = Tabs.BORROWER;
        break;
    }
  }
}